module.exports = __webpack_public_path__ + "img/camp04_close.4fe664be.png";